/**
 * The **fire mage** Arena class def (PRD #446, Slice 0, ADR-0236) - the
 * original and default class (PRD #334; fire-mage rework ADR-0179).
 *
 * This is a *view* of the shipped fire tuning, not a second copy: the def's
 * skill scalars, modifier lines, and keystone map all reference the live
 * {@link ../arenaWeapons} constants, so the extraction is byte-identical by
 * construction (its {@link ./fireMage.test} pins the def against those
 * constants so the two can never drift). The fire mage's deep cascade math
 * (`skillProjectileDamage`, `chainHopDamage`, …) stays in `arenaWeapons` - that
 * module *is* the fire mage's math; the def is only the seam struct the run
 * captures and the firing gate reads `firesWhileMoving` through.
 */

import {
  ARENA_SKILL_ID,
  ARENA_SKILL_NAME,
  ARENA_SKILL_DAMAGE,
  ARENA_SKILL_COOLDOWN_TICKS,
  ARENA_SKILL_RANGE,
  ARENA_MODIFIER_IDS,
  ARENA_KEYSTONES,
} from '../arenaWeapons';
import type { ArenaClassDef } from './types';

/**
 * The fire mage. Long a fixture: nearest-enemy auto-fire projectile, the seven
 * fire modifier lines, their keystones, no innate passive, and the shipped
 * balance floor (one-shots a tier-1 rat; volley rate clears at least half the
 * opening spawn rate, ADR-0184). `firesWhileMoving: false` keeps the ADR-0191
 * stop-to-cast gate - the mage plants to cast, unlike the archer.
 */
export const FIRE_MAGE_CLASS: ArenaClassDef = {
  id: 'fire-mage',
  name: 'Fire Mage',
  skill: {
    id: ARENA_SKILL_ID,
    name: ARENA_SKILL_NAME,
    damage: ARENA_SKILL_DAMAGE,
    cooldownTicks: ARENA_SKILL_COOLDOWN_TICKS,
    range: ARENA_SKILL_RANGE,
    firesWhileMoving: false,
  },
  modifierIds: ARENA_MODIFIER_IDS,
  keystones: ARENA_KEYSTONES,
  // No innate: the mage fights on the shared HP baseline.
  balanceFloor: {
    oneShotTier1: true,
    minSpawnClearFraction: 0.5,
    minReachableFraction: 0.25,
  },
};
